export enum MoveLayerSource {
  TOP_PANEL = 'Top panel',
  KEYBOARD = 'Keyboard',
  RIGHT_CLICK = 'Right click menu',
  RIGHT_PANEL = 'Right panel',
}
